//用户名密码登录
export default {
    userPasswordLogin(loginIfo, callback) {
        let callbackInfo = {
            ret: false,
            message: '',
            type: 'Password',
            userIds: []
        };
        if (!loginIfo.username || !loginIfo.password) {
            callbackInfo.message = window.vue.$t('component.PLEASE_INPUT_USER_OR_PD');
            return callback(callbackInfo);
        }
        /* 开始登陆 */
        let params;
        if (!loginIfo.currentToken) {
            params = {
                username: loginIfo.username,
                password: loginIfo.password,
                sysId: sessionStorage.getItem('systemId')
            };
        } else {
            params = {
                token: loginIfo.currentToken
            };
        }
        window.vue.$api.login(params, response => {
            if (response.data.statusCode === window.vue.$common.requestCode.SUCCESS_INFO_CODE && response.status === window.vue.$common.login.RESPONSE_STATUS) {
                sessionStorage.setItem('token', response.data.content.token.replace(/[\n]/g, '').replace(/[\r]/g, ''));
                sessionStorage.setItem('username', response.data.content.userName);
                sessionStorage.setItem('userLevel', response.data.content.level);
                sessionStorage.setItem('userId', response.data.content.id);
                sessionStorage.setItem('ip', response.data.content.ip);
                /* 重新登录移除原有数据 */
                sessionStorage.removeItem(window.app.sPlatformFlg + 'curentTopMenuId');
                sessionStorage.removeItem(window.app.sPlatformFlg + 'leftMenuIndexId');
                /* 初始化菜单 */
                // _this.initMenuInfo();
                window.vue.$emit('loginSucess', response);
                callbackInfo.message = window.vue.$t('javaCommon.' + response.data.statusCode);
                callbackInfo.ret = true;
                callbackInfo.userIds.push(response.data.content.id);
                // let staffDeptStationVo = {
                //     staffIdList: [sessionStorage.getItem('userId')]
                // };
                // window.vue.$api.getAllStaffInfo(staffDeptStationVo, response => {
                //     if (response.data.content.length > 0) {
                //         let structureIds = [];
                //         let structureNames = [];
                //         let stationIds = [];
                //         let stationNames = [];
                //         for (let index in response.data.content) {
                //             sessionStorage.setItem('staffName', response.data.content[index].staffName);
                //             if (response.data.content[index].structureId) {
                //                 structureIds.push(response.data.content[index].structureId);
                //             }
                //             if (response.data.content[index].structureName) {
                //                 structureNames.push(response.data.content[index].structureName);
                //             }
                //             if (response.data.content[index].stationId) {
                //                 stationIds.push(response.data.content[index].stationId);
                //             }
                //             if (response.data.content[index].stationName) {
                //                 stationNames.push(response.data.content[index].stationName);
                //             }
                //             if (response.data.content[index].leaderId) {
                //                 sessionStorage.setItem('leaderId', response.data.content[index].leaderId);
                //             }
                //             if (response.data.content[index].leaderName) {
                //                 sessionStorage.setItem('leaderName', response.data.content[index].leaderName);
                //             }
                //         }
                //         sessionStorage.setItem('stationId', stationIds);
                //         sessionStorage.setItem('stationName', stationNames);
                //         sessionStorage.setItem('structureId', structureIds);
                //         sessionStorage.setItem('structureName', structureNames);
                //     }
                // });
                return callback(callbackInfo);
            } else {
                callbackInfo.message = window.vue.$t('javaCommon.' + response.data.statusCode);
                return callback(callbackInfo);
            }
        });
    },
    loginSucess() {}
};
